<template>
  <div class="home-container">
    <div class="home">
      <div class="banner">
        <a class="banner_img"></a>
      </div>
    </div>
    <div class="content-container">
      <div class='container'>
        <div class="sidebar-menu" :style="sideListStyle">
          <el-menu
            :default-active="activeIndex"
            mode='vertical'
            active-text-color="#636363"
            text-color="#b9b9b9"
            class='el-menu-demo'
            @select="handleSelect"
          >
            <el-menu-item
              :class="items.inedx"
              :index="items.index"
              v-for="items in sideTapTitle"
              :key="items.index"
            >
              <span>
                <img v-show="activeIndex === items.index" :src="items.selectedIcon">
                <img v-show="activeIndex !== items.index" :src="items.notSelectIcon">
              </span>
              <a @click.prevent>{{ items.title }}</a>
            </el-menu-item>

          </el-menu>
        </div>
        <div class="subcontent min-contain">
          <div class="global-footprint footprint">
            <global-footprint></global-footprint>
          </div>
          <div class="bg-3">
            <img :src="imageRoot + '/common/BG_3.png'">
          </div>
          <div class="why-kiwi whykiwi">
            <why-kiwi></why-kiwi>
          </div>
          <div class="life lifekiwi">
            <LifeKiwi></LifeKiwi>
          </div>
          <div class="bg-3-bottom">
            <img :src="imageRoot + '/common/BG_3.png'">
          </div>
          <a class="home-top-button" @click.prevent="scrollHomeToTop">
            <img :src="imageRoot + '/common/top_button.png'">
          </a>
        </div>
      </div>
      <div class="bottom-img">
      </div>
    </div>
  </div>
</template>

<script>
import GlobalFootprint from '@/components/HomeComponent/GlobalFootprint.vue'
import WhyKiwi from '@/components/HomeComponent/WhyKiwi.vue'
import LifeKiwi from '@/components/HomeComponent/LifeKiwi.vue'

export default {
  data: function () {
    return {
      activeIndex: 'home',
      imageRoot: process.env.VUE_APP_IMAGE_PATH,
      sideListStyle: { top: '833px' },
      offsetTopArr: []
    }
  },
  computed: {
    sideTapTitle: function () {
      return [
        { 'index': 'home', 'title': 'Home', 'notSelectIcon': `${this.imageRoot}/home/home_icon_nor.png`, 'selectedIcon': `${this.imageRoot}/home/home_icon_select.png` },
        { 'index': 'footprint', 'title': 'Global Footprint', 'notSelectIcon': `${this.imageRoot}/home/GlobalFootprint_icon.png`, 'selectedIcon': `${this.imageRoot}/home/GlobalFootprint_icon_select.png` },
        { 'index': 'whykiwi', 'title': 'Why Kiwigame', 'notSelectIcon': `${this.imageRoot}/home/whykiwigame_icon_nor.png`, 'selectedIcon': `${this.imageRoot}/home/WhyKiwigame_icon_select.png` },
        { 'index': 'lifekiwi', 'title': 'Life at Kiwigame', 'notSelectIcon': `${this.imageRoot}/home/LifeatKiwigame_icon.png`, 'selectedIcon': `${this.imageRoot}/home/LifeatKiwigame_icon_select.png` }
      ]
    }
  },
  components: {
    GlobalFootprint,
    WhyKiwi,
    LifeKiwi
  },

  methods: {
    scrollHomeToTop () {
      window.scrollTo(0, 0)
    },
    handleSelect (key, keyPath) {
      this.activeIndex = keyPath[0]
      let moveItem = this.offsetTopArr.filter((el) => el.index === keyPath[0])[0]
      if (moveItem) {
        window.scrollTo(0, moveItem.divHeight)
      } else {
        window.scrollTo(0, 0)
      }
    },
    calcOffsetTop (s1, s2) {
      const navContents = document.querySelectorAll(s1)
      const bannerHeight = document.querySelector(s2).offsetHeight
      const offsetTopArr = []

      for (let item of navContents) {
        offsetTopArr.push({ 'index': item.classList[1], 'divHeight': item.offsetTop + bannerHeight })
      }
      /*
      navContents.forEach(item => {
        offsetTopArr.push({ 'index': item.classList[1], 'divHeight': item.offsetTop + bannerHeight })
      })
      */

      return offsetTopArr
    },
    handleSideTapOnScroll () {
      this.offsetTopArr = this.calcOffsetTop('.subcontent > div', '.banner')
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let navIndex = 'home'

      for (let n = 0; n < this.offsetTopArr.length; n++) {
        if (scrollTop >= this.offsetTopArr[n].divHeight - 10) {
          navIndex = this.offsetTopArr[n].index
        }
      }
      this.activeIndex = navIndex
    },
    handleScroll (event) {
      if (!document.querySelector('.sidebar-menu')) {
        return
      }
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let offsetTop = document.querySelector('.sidebar-menu').offsetHeight
      let totalHeight = document.documentElement.scrollHeight || document.documentElement.offsetHeight
      let offsetHeight = totalHeight - scrollTop
      let bannerHeught = document.querySelector('.banner_img').offsetHeight

      this.handleSideTapOnScroll()

      if (scrollTop <= bannerHeught) {
        offsetTop = bannerHeught * 1.07762 - Number(scrollTop)
        this.sideListStyle = { top: offsetTop + 'px' }
      } else {
        this.sideListStyle = { top: '74px' }
      }

      if (offsetHeight < 900) {
        this.$set(this.sideListStyle, 'display', 'none')
      } else {
        this.$set(this.sideListStyle, 'display', 'block')
      }
    },
    handleWindowResize (event) {
      let clientW = window.innerWidth
      let bannerHeught = document.querySelector('.banner_img').offsetHeight
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

      if (clientW > 1460 || clientW < 1460) {
        let offsetTop = bannerHeught * 1.07762 - Number(scrollTop)
        this.sideListStyle = { top: offsetTop + 'px' }
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleWindowResize)
    this.sideListStyle.top = document.querySelector('.banner_img').offsetHeight * 1.07762 + 'px'
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style lang="scss" scoped>
.bg-3-bottom{
  width: 10px;
  height: 50px;
  img{
    width: 170px;
    position: relative;
    top: -137px;
    left: 730px;
  }
}
.home-top-button{
  @include topButton(89%)
}
.bg-3{
  img{
    width: 16%;
    position: absolute;
    top: 883px;
    left: 139px;
  }
}
</style>

<style lang="scss" scoped>
.bottom-img{
  @include backgroundImage(block, 100%, 100%, "#{$imageRoot}/about/BG.png", center, no-repeat, 110% 110%,none);
  width:100%;
  height:928px;
  position: absolute;
  top:3805px;
  z-index:-1
}
</style>

<style lang='scss' scoped>
.home-container{
  margin-bottom:70px;
}
.home {
  position: relative;
  padding: 0px 0px 0px 0px;
  .banner {
    position: relative;
    //height: 771px;
    .banner_img {
      @include backgroundImage(block, 100%, 773px, "#{$imageRoot}/home/topBanner.png", center top, no-repeat, auto 100%, none);
    }
  }
}
.content-container{
  min-width:$minWidth;
}
.container{
  position:relative;
  width: 1180px;
  margin: 0 auto;
  padding: 0 10px;
  .subcontent{
    margin-left:320.8px
  }
  .sidebar-menu{
    position: fixed;
    z-index:20;
    >.el-menu{
      margin-top:20px;
      position: relative;;
      width:208px;
      border:none;
      background-color: rgba(255,255,255,0);
      background-image: url(#{$imageRoot}/home/bg_sidetap.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      left:45px;
      .el-menu-item{
        font-family: 'ubuntu';
        font-size:16px;
        height: 63px;
        &:hover{
          color: #636363 !important;
        }
        &:not(.is-disabled):focus,
        &:not(.is-disabled):hover{
          background-color: inherit !important;
        }
        &.is-active{
          background-color: inherit !important;
          //border-left:4px solid #124088 !important;
          font-size:19px;
          a{
            &::before{
              content: "";
              background: url(#{$imageRoot}/common/sidetap_select.png) no-repeat;
              background-size: 23% 100%;
              position: absolute;
              top: 30%;
              height: 50%;
              z-index: 20;
              right: 90%;
              width: 10%;
            }
          }
        }
        span{
          padding: 1.6px 9.6px 0 0;
          img{
            width:9%
          }
        }
      }
    }
  }
}

</style>

<style lang="scss" scoped>
@media only screen and (max-width: 1460px) {
  .home{
    .banner{
      height: 550px;
      .banner_img{
        height: 550px;
      }
    }
  }
  .bottom-img{
    @include backgroundImage(block, 100%, 100%, "#{$imageRoot}/about/BG.png", center, no-repeat, 110% 110%,none);
    width:100%;
    height:928px;
    position: absolute;
    top:3605px;
    z-index:-1
  }
  .bg-3-bottom{
    width: 10px;
    height: 50px;
    img{
      width: 170px;
      position: relative;
      top: -137px;
      left: 730px;
    }
  }
}
</style>
